import React from 'react';
import styled from 'styled-components';
import IconArrowDown from 'assets/icons/ic-arrow-down.svg';

import { Accordion, BodyText, SvgIcon } from '@make-software/cspr-design';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: 4
}));

const CollapsibleRow = styled.div(({ theme }) =>
  theme.withMedia({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 40,
    background: theme.styleguideColors.fillSecondary,
    '&:hover': {
      span: {
        color: theme.styleguideColors.contentRed
      }
    }
  })
);

const StyledIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.contentTertiary,
    [`${CollapsibleRow}:hover &`]: {
      color: theme.styleguideColors.contentRed
    }
  })
);

export const InfoAccordion = ({ children, ...props }: any) => {
  return (
    <StyledAccordion {...props} style={{}}>
      {({ isOpen }) => (
        <CollapsibleRow>
          <BodyText size={1} style={{ marginLeft: '20px' }}>
            {children}
          </BodyText>
          <StyledIcon src={IconArrowDown} rotate={isOpen} style={{ marginRight: '20px' }} />
        </CollapsibleRow>
      )}
    </StyledAccordion>
  );
};
